import { useEffect, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  defaultValue?: string;
  size?: "sm" | "lg";
  placeholder?: string;
  onSearch?: (keyword: string) => void;
  autoFocus?: boolean;
}

export default function SearchBar({
  defaultValue = "",
  size = "sm",
  placeholder = "搜索电影、电视剧、综艺、动漫",
  onSearch,
  autoFocus = false,
}: SearchBarProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (onSearch) {
      onSearch(keyword);
      return;
    }
    navigate(keyword ? `/search?q=${encodeURIComponent(keyword)}` : "/search");
  };

  const isLarge = size === "lg";

  return (
    <form
      onSubmit={handleSubmit}
      className={`flex w-full items-center gap-2 rounded-full border border-background-200 bg-background-100 transition-colors focus-within:border-primary-400 ${
        isLarge ? "h-11 pl-4 pr-1.5 md:h-12" : "h-9 pl-3 pr-1"
      }`}
      role="search"
    >
      <i
        className={`ri-search-line shrink-0 text-foreground-400 ${isLarge ? "text-lg" : "text-base"}`}
        aria-hidden="true"
      />
      <input
        type="search"
        value={value}
        autoFocus={autoFocus}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索影视作品"
        className={`min-w-0 flex-1 bg-transparent font-body text-foreground-900 outline-none placeholder:text-foreground-400 ${
          isLarge ? "text-sm md:text-base" : "text-sm"
        }`}
      />
      <button
        type="submit"
        className={`shrink-0 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 font-medium text-background-50 transition-colors hover:bg-primary-600 ${
          isLarge ? "h-9 px-5 text-sm" : "h-7 px-3 text-xs"
        }`}
      >
        搜索
      </button>
    </form>
  );
}